import { render } from "./page-loading.vue?vue&type=template&id=5693bed8&scoped=true"
import script from "./page-loading.vue?vue&type=script&lang=js"
export * from "./page-loading.vue?vue&type=script&lang=js"

import "./page-loading.vue?vue&type=style&index=0&id=5693bed8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1381316803/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5693bed8"]])

export default __exports__